import { SecondaryButton } from 'sharedComponents/Buttons';
import { CandidateNavbarDataTestIds } from 'data-testids/general';
import { connectRedirectUrls } from 'utils/constants/urls';
import { CONNECT_JOBBOARD_STATES } from 'utils/constants/connect';
import { NAVBAR_BUTTON_LABELS } from 'utils/constants';
import { signupButtonStyles } from './styles';
import { createButtonUrl } from 'features/Connect/features/ExpressInterest/utils';
import { useHistory } from 'react-router-dom';
import { NavBarButtonProps } from '../types';
import { useTheme } from '@mui/material';
export const SignupButton: React.FC<NavBarButtonProps> = ({ jobBoardState }) => {
  const history = useHistory();
  const theme = useTheme();

  const handleSignUpRedirect = () => {
    history.push(
      createButtonUrl({
        basePath: connectRedirectUrls.SIGN_UP,
        jobboardState: CONNECT_JOBBOARD_STATES[jobBoardState].urlParam,
      })
    );
  };

  return (
    <SecondaryButton
      sx={signupButtonStyles(theme)}
      onClick={handleSignUpRedirect}
      dataTestId={CandidateNavbarDataTestIds.SIGN_UP_BUTTON}
    >
      {NAVBAR_BUTTON_LABELS.SIGN_UP}
    </SecondaryButton>
  );
};
